import React from 'react';
import { Rule } from 'src/helpers/rulesEngine';
import Alert from 'src/components/Alert/';
import { AlertRulesEngineOptions, hasDismissedAlert } from 'src/helpers/alerts';

const StripeVerificationPendingAlert: Rule<
  JSX.Element,
  AlertRulesEngineOptions
> = (state, options) => {
  const {
    requiredFields,
    legalEntityVerificationStatus,
  } = state.stripeVirtualAccount;
  const alertKey = 'stripe_verification_pending';

  if (
    requiredFields.length === 0 &&
    legalEntityVerificationStatus === 'Pending' &&
    !hasDismissedAlert(state.page.id, alertKey)
  ) {
    return {
      matched: true,
      result: (
        <Alert
          id={alertKey}
          type="amber"
          onClose={options!.onClose}
          page={state.page}
        >
          <p className="jg-space-mbn">
            Thank you! We will check your details and we will let you know once
            we have confirmed everything is ok.
          </p>
        </Alert>
      ),
    };
  }

  return { matched: false };
};

export default StripeVerificationPendingAlert;



// WEBPACK FOOTER //
// ./src/helpers/alerts/StripeVerificationPendingAlert.tsx